import { isServer } from 'utilities/window'

type Props = {
  children: string | JSX.Element | JSX.Element[],
}

const NoSsr = ({ children }: Props) => {
  if (isServer()) {
    return <></>
  }
  return <>{ children }</>
}

export default NoSsr
